import React from 'react';
import PropTypes from 'prop-types';
import withTranslate from 'components/withTranslate';

const formatLocation = (city, state) => {
  if (city && state) return `${city}, ${state}`;
  return city || state || '';
};

export const ScanDataTable = ({ scanEvents, _t }) => {
  if (!scanEvents || scanEvents.length === 0) {
    return null;
  }

  return (
    <div className="scan-data-table-wrapper">
      <p className="scan-data-label">
        {_t('Ballot location based on USPS scan data:')}
      </p>
      <table
        className="scan-data-table"
        role="table"
        aria-label={_t('Ballot location based on USPS scan data')}
      >
        <thead role="rowgroup">
          <tr role="row">
            <th scope="col" role="columnheader">
              {_t('Scan Date and Time')}
            </th>
            <th scope="col" role="columnheader">
              {_t('Scan Event')}
            </th>
            <th scope="col" role="columnheader">
              {_t('Scan Location')}
            </th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          {scanEvents.map((scanEvent, index) => (
            <tr key={index} role="row">
              <td
                role="cell"
                className="scan-data-timestamp"
                data-label={_t('Scan Date and Time')}
              >
                {scanEvent.scan_timestamp}
              </td>
              <td
                role="cell"
                className="scan-data-event"
                data-label={_t('Scan Event')}
              >
                {_t(scanEvent.scan_event)}
              </td>
              <td
                role="cell"
                className="scan-data-location"
                data-label={_t('Scan Location')}
              >
                {formatLocation(
                  scanEvent.facility_city,
                  scanEvent.facility_state,
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ScanDataTable.propTypes = {
  _t: PropTypes.func.isRequired,
  scanEvents: PropTypes.arrayOf(
    PropTypes.shape({
      scan_timestamp: PropTypes.string.isRequired,
      scan_event: PropTypes.string.isRequired,
      facility_city: PropTypes.string,
      facility_state: PropTypes.string,
    }),
  ),
};

export default withTranslate(ScanDataTable);
